module.exports = __webpack_public_path__ + "static/ep-bf4725d679a29b246c8cc7ba022d201a.jpg";